import { render, staticRenderFns } from "./QuestionnaireAdd.vue?vue&type=template&id=1afc7554&scoped=true&"
import script from "./QuestionnaireAdd.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireAdd.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireAdd.vue?vue&type=style&index=0&id=1afc7554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc7554",
  null
  
)

export default component.exports